import { componentOutletConfigFactory } from '@recruitee/common';
import { injectTranslate } from '@recruitee/i18n';
import { EMPTY_CELL, TagsCellComponent } from '@recruitee/user-interface';

import { defineOfferTableColumn } from './utils';
import { OfferColumnId } from '../../../offers-page/offers-table/offers.table-service';

export const languagesColumn = defineOfferTableColumn(() => ({
  id: OfferColumnId.Languages,
  label: injectTranslate()('app.offers.table.languages'),
  visible: true,
  geometry: {
    width: 155,
    minWidth: 155,
    autoFitProp: 'width',
  },
  options: {
    draggable: false,
    resizable: true,
    removable: true,
    sortable: false,
  },
  componentFactory: ({ row }) => {
    if (!row.enabledLanguages?.length) return EMPTY_CELL;

    return componentOutletConfigFactory(TagsCellComponent, {
      inputs: {
        tags: row.enabledLanguages.map(({ name }) => name),
        disabled: true,
        isHoverable: false,
      },
    });
  },
}));
